import { http } from "./http";

export async function whoIsArriving(dateStr) {
  return (await http.request(`api/whoisarriving/${dateStr}`)) || [];
}

export async function whoIsLeaving(dateStr) {
  return (await http.request(`api/whoisleaving/${dateStr}`)) || [];
}

export async function listInternalTransfersOnDate(dateStr) {
  return (await http.request(`api/transfers/internal?date=${dateStr}`)) || [];
}
